// BackorderBadge - Signals a line can only be fulfilled on backorder
// (supplier backorder enabled, product eligible, date available).
//
// Three visual variants:
//   - "blue": original compact pill, still exported as the default so
//     legacy call-sites keep working. New surfaces should use "amber-plain".
//   - "amber-plain": DEV-51188 unified variant used on Search + PDP —
//     same amber colours + typography + padding as the cart pill below,
//     but without the warning icon so it fits alongside the smaller
//     PREFERRED / CLOSEST / IN STOCK badges in the badges row. Client
//     feedback: amber reads as more eye-catching than the muted blue.
//   - "amber": DEV-51018 cart variant matching the engineer mock —
//     identical colours + typography to "amber-plain", plus a
//     TriangleAlert icon that only makes sense on the cart line (where
//     a backordered item sits next to an "In stock" green sibling and
//     needs the stronger call-out).

import { TriangleAlert } from 'lucide-react'

export interface BackorderBadgeProps {
  className?: string
  variant?: 'blue' | 'amber-plain' | 'amber'
}

export function BackorderBadge({ className = '', variant = 'blue' }: BackorderBadgeProps) {
  if (variant === 'amber') {
    return (
      <span
        className={`inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-semibold bg-amber-50 text-amber-800 px-2 py-1 rounded ${className}`}
      >
        <TriangleAlert className="w-3.5 h-3.5" aria-hidden="true" />
        BACKORDER
      </span>
    )
  }
  if (variant === 'amber-plain') {
    return (
      <span
        className={`inline-flex items-center whitespace-nowrap text-xs font-semibold bg-amber-50 text-amber-800 px-2 py-1 rounded ${className}`}
      >
        BACKORDER
      </span>
    )
  }
  return (
    <span
      className={`inline-block whitespace-nowrap text-[11px] bg-blue-50 text-blue-700 px-2 py-0.5 rounded-md font-medium ${className}`}
    >
      BACKORDER
    </span>
  )
}
